import gsap from "gsap";

export function handleScrollingRotatingElements() {
    $('.js-rotating-circle').each(function () {
        handleScrollingRotatingElement($(this));
    });
}

function handleScrollingRotatingElement($element) {
    gsap.to($element.find('svg'), {
        scrollTrigger: {
            trigger: $element.parents('.js-section'),
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
        },
        rotate: 180,
        ease: "none"
    });
}